import { UserActionLogRequest } from './../../../../models/user-action-log.model';
import { AppConfig } from './../../../../app.config';
import * as utils  from 'src/core/app/common/utils';
import { Animations } from './../../../../Animations';
// external imports
import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ZIndexMngr } from '@core_n/common/ZIndexMngr';
import { SensorObject } from 'src/app/asp/SensorObject';
import { AnalyticsMngrService } from '@core_n/msg/analytics-mngr.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { VideoMsgMngrService } from '@core_n/msg/video-mngr.service';
import { Subscription } from 'rxjs';
import { userSettings } from '@core_n/common/settings';
import { MsgBoxService } from '@core_n/msg-boxes/msg-box.service';
import { VideoPlayerType } from '@core_n/models/camera.model';

@Component({
  selector: 'app-video-player-window',
  templateUrl: './video-player-window.component.html',
  styleUrls: ['./video-player-window.component.scss'],
  animations: [
    Animations.WindowOpenCloseFadeHeight
  ]
})

export class VideoPlayerWindowComponent extends ZIndexMngr implements OnInit, OnDestroy {
  static readonly DIALOG_ID = 'video-player-window';

  public sensor: SensorObject;
  public sensorID: number;
  public selectedChannel: string | null = null;
  public channels: string[] = [];
  public channelsDaynamic: any = [];
  public selectedValue :any
  public streamName: string = "";
  // accordion stuff
  public isOpen = false;

  // sub
  private channelsSub!: Subscription;
  private analysisSub!: Subscription;

  public canSetChannel: boolean = false;
  public canSetDaynamicChannel: boolean = false;
  public canSetAnalytics: boolean = false;
  public analysisToggleState: boolean = false;
  public analysisStream: boolean = false;
  public ztubeToggleState: boolean = false;
  public isUpdatingZtubeState: boolean = false;
  analysisLimit: number;
  channelsLimit: number;
  public videoPlayerType: VideoPlayerType = "jwPlayer";
  MaxOpenWindows: number;

  constructor(public dialogRef: MatDialogRef<VideoPlayerWindowComponent>,
    elementRef: ElementRef,
    public analyticsMngrService: AnalyticsMngrService,
    protected videomngr: VideoMsgMngrService,
    protected msgBox: MsgBoxService
  ) {
    super(elementRef);


    this.canSetChannel = userSettings.canSetChannel;
    this.canSetDaynamicChannel=userSettings.canSetDaynamicChannel;
    this.canSetAnalytics = userSettings.canSetAnalytics;
    this.analysisLimit = AppConfig.settings.analysisAddress.limit;
    this.channelsLimit = AppConfig.settings.videoAddress.channelsLimit;
    this.videoPlayerType = AppConfig.settings.videoAddress.videoPlayerInfo.type;
    this.MaxOpenWindows = AppConfig.settings.videoAddress.numberOfOpenWindows;
  }

  ngOnInit(): void {
     this.channelsDaynamic = AppConfig.chanels;
    this.selectedChannel=""
    if (this.MaxOpenWindows <= this.videomngr.getcountOpenVideo()) {
      this.msgBox.showConfirmMsgBox("cameras limit is reached.\nRemove a camera from the list and try again.", "Cameras limit info", 'OK');
      return;
    } else {
      this.videomngr.setcountOpenVideo(1)
    }

    this.analysisSub! = this.videomngr.VideosInAnalysis$.subscribe(list => {
      if (list.some(i => i.cameraStreamName.toLowerCase() === this.sensor.streamName.toLowerCase()))
        this.analysisToggleState = true;
      else
        this.analysisToggleState = false;
    })

    this.channelsSub! = this.videomngr.ChannelList$.subscribe(map => {
      this.ztubeToggleState = map.has(this.sensor.streamName);
      this.isUpdatingZtubeState = false;
      const val =Array.from(map.values()).filter(v=>v.cameraName==this.sensor.name).map(c=>c.cameraStreamName);
      this.selectedChannel = val[0].replace(/\.stream$/,'');
      this.channels = Array.from(map.keys());
    })
  }


  logUserAction(sns: SensorObject) {
    const userLog: UserActionLogRequest = {
      actionType: "Open",
      targetAction: "Camera",
      targetName: sns.name,
      targetId: sns.sensorID
    }
    this.videomngr.logUserAction(userLog);
  }

  ngOnDestroy(): void {
    this.videomngr.setcountOpenVideo(-1)
    this.channelsSub.unsubscribe();
    this.analysisSub.unsubscribe();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.windowVisible.next(true);
      this.dialogRaise();
    })
  }

  setSensor(sns: SensorObject) {
    this.sensor = sns;
    this.sensorID = sns.sensorID;

    try {
      this.streamName = this.sensor.streamName.split('.')[0];
    }
    catch {
      this.streamName = this.sensor.streamName;
    }
    this.logUserAction(this.sensor);
  }

  static createDialogConfig(sensor: SensorObject) {
    let dialogConfig = utils.createDialogConfig(true);
    dialogConfig.data = { sensor: sensor };
    dialogConfig.panelClass = 'containerforaspect';
    return dialogConfig;
  }

  onAnalyticsClick(event: MatSlideToggleChange) {
    if (this.videomngr.getVideosInAnalysisList().length > this.analysisLimit) {
      event.checked = false;
      this.msgBox.showConfirmMsgBox("Analysis limit is reached.\nRemove a camera from the list and try again.", "Analysis limit info", 'OK');
    }
    else {
      try {

        this.videomngr.updateVideoAnalysisState(this.sensor.streamName, this.sensor.res, event.checked);
      }
      catch (e) {
        console.error("cannot send videomngr update: " + e);
      }
      finally {
        setTimeout(() => {
          try {
            this.analyticsMngrService.sendAnalticsRequest(this.sensor.streamName, this.sensor.res, event.checked, this.sensor.workModeType);
          }
          catch (e) {
            console.error("cannot send vid to analysis: " + e);
          }
        }, event.checked ? AppConfig.settings.analysisAddress.delay : 1000);
      }
    }
  }

  onAnalyticsVideoClick(event: MatSlideToggleChange) {
  }

  onZtubeClick(event: MatSlideToggleChange) {
    if (this.channels.length > this.channelsLimit) {
      event.checked = false;
      this.msgBox.showConfirmMsgBox("Sending to Ztube limit is reached.", "Ztube limit info", 'OK');
    }
    else {
      this.isUpdatingZtubeState = true;
      try {
        this.videomngr.setChannelStreamConnectionState(this.sensor.streamName, event.checked);
      }
      catch (e) {
        console.error("Cannot send to ztube: " + e);
        this.isUpdatingZtubeState = false;
      }
    }
  }

  onchannelsDaynamic(event:any){
    
   console.log(event.value)
   try {
        const channelsDaynamic= event.value+".stream"
        this.videomngr.setChannelDaynamicStreamConnectionState(this.sensor.streamName,channelsDaynamic ,false);
      }
      catch (e) {
        console.error("Cannot send to ztube: " + e);
        this.isUpdatingZtubeState = false;
      }
  }
  toggle() {
    this.isOpen = !this.isOpen;
  }
}